import { __awaiter, __generator } from "tslib";
import { TrustApiError } from '../errors';
export var createAppleTokenBindingApi2 = function (apiHost, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = new URL('/web/create_verification_intent', apiHost);
                url.searchParams.append('service_token', params.serviceToken);
                return [4, fetch(url, {
                        method: 'post',
                        headers: new Headers({
                            'Content-Type': 'application/json'
                        }),
                        body: JSON.stringify({
                            currency: params.currency,
                            form_params: {
                                integrationProfileId: params.integrationProfileId,
                                mode: params.mode,
                                flow: 'apple-pay',
                                apple_pay_preset: params.applePayPreset,
                                query_params: {
                                    theme: params.theme,
                                    lang: params.lang,
                                    layout: params.layout
                                }
                            }
                        }),
                        credentials: 'include'
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new TrustApiError("".concat(response.status, " server error"));
                }
                return [4, response.json()];
            case 2:
                json = _a.sent();
                return [2, json.form_url];
        }
    });
}); };
